<template>
  <CountTo :startVal="startVal" :endVal="endVal" :duration="duraction" v-bind="attr" />
</template>

<script>
import CountTo from 'vue-count-to'
export default {
  name: 'CountAnimation',
  components: {
    CountTo,
  },
  props: {
    startVal: {
      // 初始值
      type: Number,
      default: 0,
    },
    endVal: {
      // 结束值
      type: Number,
      default: 0,
    },
    duraction: {
      // 动画时长
      type: Number,
      default: 2000,
    },
    attr: {
      // 配置项
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style></style>
